export const Z_INDEX_DEFINITIONS = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    popper: 1400,
    menu: 1500,
    snackbar: 1600,
    tooltip: 1700,
};
//# sourceMappingURL=zIndex.js.map